<template>
  <transition name="slide">
    <div class="project-update">
      <div class="wizard-toolbar">
        <div class="grid-2">
          <div class="progress-step-1 done">
            <div class="bar"></div>
            <p>{{ $t('ui.project_wizard.step1-title') }}</p>
          </div>

          <div class="progress-step-2 active">
            <div class="bar"></div>
            <p>{{ $t('ui.project_wizard.step2-title') }}</p>
          </div>
        </div>
      </div>

      <h2>{{ $t('ui.project_wizard.step2-title') }}</h2>

      <!-- if talent -->
      <form v-if="planIsTalent" class="project-update--form" @submit.prevent>
        <p class="form-subtitle">
          {{ $t('ui.project_wizard.businesskits') }}<i class="icon icon-help-circle"></i>
        </p>

        <field
          class="lead-sheet-selector"
          :errors="errors"
          model="project"
          ref="businesskit"
          rel="businessKitId"
          name="business_kit_id"
          type="select"
          :params="{
          no_i18n:
          true}"
          :collection="businessKitList"
          v-model="item.business_kit_id"
          @input="setBusinessKit"
        />

        <div class="lead-sheet-custom" ref='custom' @click="setBusinessKit('custom')">
          <p>
            {{ $t('ui.project_wizard.leadsheet-create')}}
          </p>
        </div>
      </form>

      <!-- if not talent -->
      <form v-else class="project-update--form" @submit.prevent>
        <p class="form-subtitle">
          {{ $t('ui.project_wizard.lead-sheets') }}<i class="icon icon-help-circle"></i>
        </p>

        <div class="row justify-between">
          <div class="leadsheet-box leadsheet-basic" ref='basic' @click="setLeadSheet('basic');">
            <img src="../../../../assets/leadsheet-standard.svg">
            <p>Standard</p>
          </div>

          <div class="leadsheet-box leadsheet-advanced" ref='advanced' @click="setLeadSheet('advanced')">
            <img src="../../../../assets/leadsheet-advanced.svg">
            <p>Advanced</p>
          </div>
        </div>

        <field
          v-if="hasLeadMasks"
          class="lead-sheet-selector"
          :errors="errors"
          model="project"
          ref='leadMaskId'
          @input="setLeadMaskId"
          v-can="'lead_masks.list'"
          name="lead_mask_id"
          :params="{ no_i18n: true}"
          type="select"
          :collection="leadMasks"
          v-model="item.lead_mask_id"
        />

        <div class="lead-sheet-info" v-if="['basic', 'advanced'].includes(currentlySelected)">
          <p class="tip">
            <i class="icon yule-icon-info"></i>
            <span v-if="currentlySelected == 'basic'">
              {{ $t('ui.project_wizard.leadsheet-basic') }}
            </span>
            <span v-else-if="currentlySelected == 'advanced'">
              {{ $t('ui.project_wizard.leadsheet-advanced') }}
            </span>
          </p>
        </div>
      </form>

      <div class="actions wizard-footer">
        <button class="btn btn-tertiary btn-flat" @click="previousStep()">
          {{ $t('ui.pages.previous') }}
        </button>

        <a class="cancel" @click="cancel()">
          {{ $t('ui.global.cancel') }}
        </a>

        <button class="btn btn-primary btn-flat btn-save" @click="create()">
          {{ $t('ui.pages.project-create-button') }}
        </button>
      </div>
    </div>
  </transition>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'

export default {
  components: {
    Field,
  },
  data() {
    return{
      hasLeadMasks: this.leadMasks.length > 0,
      currentlySelected: null
    }
  },
  props: {
    item: {
      type: Object
    },
    leadMasks: {
      type: Array
    },
    businesskits: {
      type: Array
    }
  },
  computed: {
    errors() {
      return this.$store.getters.getProjectWizardErrors
    },
    businessKitList() {
      return this.businesskits.map((item) => ({'name': item.name, 'value': item.id}))
    },
    planIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent
    }
  },
  mounted() {
    this.clearSelected();
    this.setLeadSheet('basic');
  },
  methods: {
    setBusinessKit(kit) {
      // sometimes the field calls this method with kit === undefined
      if (!kit) { return }
      this.clearSelected()
      if (kit === 'custom') {
        var reference = this.$refs['custom']
      } else {
        var reference = this.$refs['businesskit'].$el
      }
      reference.classList.add('selected')
      this.item.business_kit_id = kit
    },
    // When coming from the drop-down
    setLeadMaskId(maskId) {
      if (maskId) {
        this.clearSelected()
        let reference = this.$refs['leadMaskId'].$el
        reference.classList.add('selected')
        this.item.lead_mask_id = maskId
        this.item.lead_sheet   = null
        this.currentlySelected = null
      }
    },
    // When clicking one of the big selectors
    setLeadSheet(leadSheet){
      this.clearSelected()
      let reference = this.$refs[leadSheet]
      reference.classList.add('selected')
      // Clear out lead_mask_id in case drop-down was selected before
      this.item.lead_mask_id = null
      this.item.lead_sheet   = leadSheet
      this.currentlySelected = leadSheet
    },
    clearSelected() {
      Object.keys(this.$refs).forEach((key) => {
        let el = this.$refs[key]
        // Some refs are objects so we need to fetch the actual element
        if (el.$el) {
          el = el.$el
        }
        el.classList.remove('selected')
      })
    },
    cancel() {
      this.$store.commit('RESET_PROJECT_WIZARD_ERRORS')
      this.$store.commit('SET_PROJECT_WIZARD_STEP', 1)
      this.$router.push({
        name: "projects"
      })
    },
    previousStep() {
      this.$store.commit('INCREMENT_PROJECT_WIZARD_STEP', -1)
    },
    validate() {
      this.$store.commit('RESET_PROJECT_WIZARD_ERRORS')
      if (!this.planIsTalent && !this.item.lead_sheet && !this.item.lead_mask_id) {
        this.$store.commit('ADD_PROJECT_WIZARD_ERROR', {
          field_name: 'lead_mask_id',
          code: `project.lead_mask_id.invalid`
        })
      } else if (this.planIsTalent && !this.item.business_kit_id) {
        this.$store.commit('ADD_PROJECT_WIZARD_ERROR', {
          field_name: 'business_kit_id',
          code: `project.business_kit_id.invalid`
        })
      }
      return this.errors.length == 0
    },
    create() {
      let valid = this.validate()
      if (valid) {
        if (this.item.business_kit_id === 'custom') {
          delete this.item.business_kit_id
          this.$store.commit('PROJECT_WIZARD_CUSTOM_BUSINESS_KIT', true)
        }
        this.$emit('create')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.wizard.step-2 {
  .leadsheet-box {
    width: 170px;
    height: 176px;
    background-color: #F3F5F6;
    text-align: center;
    border: 2px solid #F3F5F6;
    border-radius: 4px;
    cursor: pointer;
    transition: all .15s ease-out;
    @media(max-width: 575px) {
      margin-bottom: .5em;
    }
    img {
      margin-top: 1.5em;
    }
    &.selected{
       border: 2px solid #007AFF;
    }
  }
  .lead-sheet-custom {
    padding-bottom: 1em;
    text-align: center;
    cursor: pointer;
    background: #F3F5F6;
    padding: 1em;
    margin-bottom: 1em;
    margin-top: 1em;
  }


  .selected{
     border: 2px solid #007AFF;
     transition: .3s all ease-in;
     border-radius: 4px;
  }

  .lead-sheet-info {
    margin-top: 10px;
  }

  // .input--checkbox + label {
  //
  //   font-size: 15px;
  //   padding-left: 1.7em;
  // }
  //
  // .input--checkbox + label:before,
  // .input--checkbox + label:after {
  //
  //   margin-top: 0;
  //   width: 13px;
  //   height: 13px;
  // }


  .tip {
    color: #6A7A8A;
    font-size: 15px;
    i {
      vertical-align: text-bottom;
      margin-right: .1em;
      font-size: 1em;
    }
  }
  .lead-sheet-selector{
    background: #F3F5F6;
    padding: 1em;
    margin-bottom: 1em;
    margin-top: 1em;
    padding-bottom: 0.3em;
  }
  .grid-2 {
    @media(min-width: 408px) {
      display: flex;
    }
  }
  .hidden {
    display: none;
  }
  .show {
    display: block;
  }

}
@media(max-width: 575px) {
  .wizard.step-2 .leadsheet-box {
    width: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// StepTwo.vue?42fc7234